<script setup>
import { useGA } from '#/useGA'
import gsap from 'gsap'
import { inject, onMounted, ref, watch } from 'vue'
import AppButton from '#/general/AppButton'
import { useVModel } from '@vueuse/core'

const { event } = useGA()
const { screen } = inject('Shared')
const props = defineProps({ always: Boolean, visible: Boolean })
const emit = defineEmits(['update:visible'])
const visible = useVModel(props, 'visible', emit)
const allowed = ref(false)

watch(visible, v => {
  if (v) {
    gsap.to('.contact--container', { duration: 1, right: '0px' })
  } else {
    gsap.to('.contact--container', { duration: 1, right: '-377px' })
  }
})
watch(allowed, v => {
  if (v) {
    gsap.to('.contact--container', { duration: 1, right: '-377px' })
  } else {
    gsap.to('.contact--container', { duration: 1, right: '-433px' })
  }
})

const navigationEvent = () => {
  event('button', { eventCategory: 'button', eventLabel: 'Zur B2B Lösung - B2B' })
  window.open('https://share.hsforms.com/1J0BuBtRqQn2hnK3S8a-ocA595kq', '_blank').focus()
}

onMounted(() => {
  if (props.always) {
    allowed.value = true
  } else {
    window.addEventListener('scroll', () => {
      allowed.value = window.scrollY > (window.innerHeight - 200)
    })
  }
})
</script>

<template lang="pug">
.contact--container
  .contact--content
    .contact--sticky-btn(@click="visible = !visible")
      .contact--sticky-svg
        svg(width='34' height='35' viewBox='0 0 34 35' fill='none' xmlns='http://www.w3.org/2000/svg')
          g(clip-path='url(#clip0_7157_13110)')
            path(d='M30.79 25.6299H25.16V32.6799L17.63 26.1699C17.23 25.8199 16.71 25.6299 16.18 25.6299H3.21C1.99 25.6299 1 24.6399 1 23.4199V3.33988C1 2.11988 1.99 1.12988 3.21 1.12988H30.79C32.01 1.12988 33 2.11988 33 3.33988V23.4199C33 24.6399 32.01 25.6299 30.79 25.6299Z' stroke='white' stroke-width='2' stroke-miterlimit='10')
            path(d='M8.53125 14.6597C9.77389 14.6597 10.7812 13.6523 10.7812 12.4097C10.7812 11.167 9.77389 10.1597 8.53125 10.1597C7.28861 10.1597 6.28125 11.167 6.28125 12.4097C6.28125 13.6523 7.28861 14.6597 8.53125 14.6597Z' fill='white')
            path(d='M17 14.6597C18.2426 14.6597 19.25 13.6523 19.25 12.4097C19.25 11.167 18.2426 10.1597 17 10.1597C15.7574 10.1597 14.75 11.167 14.75 12.4097C14.75 13.6523 15.7574 14.6597 17 14.6597Z' fill='white')
            path(d='M25.4688 14.6597C26.7114 14.6597 27.7188 13.6523 27.7188 12.4097C27.7188 11.167 26.7114 10.1597 25.4688 10.1597C24.2261 10.1597 23.2188 11.167 23.2188 12.4097C23.2188 13.6523 24.2261 14.6597 25.4688 14.6597Z' fill='white')
          defs
            clipPath#clip0_7157_13110
              rect(width='34' height='34.74' fill='white' transform='translate(0 0.129883)')
      .contact--sticky-label
        div Ihr
        div Raumpionier
    .contact--body
      .contact--close(@click="visible = false")
        svg(width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg')
          path(d='M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z' fill='white')
      img.contact--img(v-lazy="{ src: '/Atilla.png' }")
      .contact--text
        div Das Potenzial Ihres Hauses lässt Ihnen keine Ruhe?
        div Wir helfen Ihnen gerne weiter!
      .contact--text
        div Atilla Färber, CEO
        a(target="_blank" href="mailto:atilla@raumpioniere.ch") atilla@raumpioniere.ch
        a(target="_blank" href="tel:+41715212126") +41 71 521 21 26
      app-button.contact--submit(@click="navigationEvent" label="Jetzt Kontakt aufnehmen")
</template>

<style lang="sass">
.contact--container
  display: flex
  flex-direction: row
  position: fixed
  z-index: 1000
  color: #FFFFFF
  font-weight: 600
  line-height: 125%
  background: #2D3646
  right: -433px
  @media screen and (min-width: 600px)
    font-size: 20px
    border-radius: 0px 0px 0px 10px
    top: calc(50% - 195px)
  @media screen and (max-width: 600px) and (min-width: 400px)
    top: calc(50% - 41px)
    font-size: 16px
  @media screen and (max-width: 400px)
    top: calc(100vh - 430px)
    font-size: 16px
  .contact--content
    position: relative
    .contact--sticky-btn
      cursor: pointer
      background: #2D3646
      position: absolute
      top: 0px
      display: flex
      justify-content: center
      align-items: center
      border-radius: 10px 0px 0px 10px
      width: 56px
      @media screen and (min-width: 600px)
        left: -56px
        height: 319px
        padding: 12px 28px
      @media screen and (max-width: 600px)
        border-radius: 10px 0px 0px 10px
        left: -56px
        height: 63px
      .contact--sticky-svg
        margin: 3px 0 0 6px
        display: flex
        justify-content: center
        align-items: center
        @media screen and (min-width: 600px)
          display: none
      .contact--sticky-label
        display: flex
        flex-direction: row
        transform: rotate(-90deg)
        white-space: nowrap
        text-overflow: clip
        @media screen and (max-width: 600px)
          display: none
        div
          margin-right: 10px
  .contact--body
    padding: 30px
    width: 377px
    @media screen and (min-width: 600px)
      height: 480px
    @media screen and (max-width: 600px)
    .contact--close
      position: absolute
      width: 14px
      height: 14px
      right: 21px
      top: 21px
      cursor: pointer
    .contact--img
      margin-bottom: 30px
      border-radius: 100%
      height: 150px
      width: 150px
      object-fit: cover
    .contact--text
      margin-bottom: 18px
      display: flex
      flex-direction: column
      a
        text-decoration: none !important
        width: 100%
        color: white !important
    .contact--submit
      position: absolute
      height: 56px
      left: 30px
      width: calc(100% - 60px)
      background: #1F47CD
      border-radius: 10px
      @media screen and (min-width: 600px)
        bottom: -28px
      @media screen and (max-width: 600px)
</style>
